import React, { useState, useEffect } from 'react';
import DashboardAction from './actions/dashboardAction';
import { url, urlAssets } from '../../config/global';
import './UserDashboard.css';
import { Redirect } from 'react-router-dom';
import Axios from 'axios';

const UserDashboard = () => {
    const [apps, setApps] = useState([]);
    const [roleApps, setRoleApps] = useState([]);

    const getApps = () => {
        DashboardAction({type: 'apps'}, sessionStorage.getItem('token')).then((res) => {
          setApps(res)
        });
    }

    const getUser = () => {
        const _idUser = sessionStorage.getItem('_id');
        Axios.get(`${url}/user/${_idUser}`, {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            },
          }).then((res) => {
            setRoleApps(JSON.parse(res.data.data.role_apps))
        }).catch((err) => {
            if (err.response) {
                console.log(err)
              if (err.response.status === 401) {
                sessionStorage.removeItem('token');
              }
            }
        });
    }

    const generateToken = async () => {
        return Axios.get(`${url}/apps/get-token`, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem('token')}`
            }
        }).then(res => {
            return res.data
        })
    }

    const handleClick = async (item) => {
        await DashboardAction({type: 'log/create'}, sessionStorage.getItem('token'), {app_id: item._id})
        const ssoToken = await generateToken()
        window.open(`${item.link_path}/sso?token=${ssoToken.sso_token}`, '_blank')
    }

   
    useEffect(() => {
        getApps();
        getUser();
    }, []);

    return sessionStorage.getItem('token') ? (
        <>
            <div className="row match-height">
                {apps.length > 0 && apps.map((app) => (
                    roleApps[app._id] 
                    ?
                        <div className="col-md-6 col-lg-4">
                            <div onClick={() => handleClick(app)} className="pointer">
                                <div className="card text-center">
                                    <div className="card-body">
                                        <img className="img-fluid my-2 img-access-link" src={`${urlAssets}/list_apps/${app.logo}`} alt={app.application_name} />
                                    </div>
                                    <div className="card-footer text-muted p-1 border-none">
                                        <p className="card-text">{app.application_name}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    : ''
                ))}
            </div>
        </>
    ) : <Redirect to="/login" />
}

export default UserDashboard;